module.exports = __webpack_public_path__ + "img/info.89001e5a.svg";